import { render, staticRenderFns } from "./JMixinsDemo.vue?vue&type=template&id=0002a6e8"
import script from "./JMixinsDemo.vue?vue&type=script&lang=js"
export * from "./JMixinsDemo.vue?vue&type=script&lang=js"
import style0 from "./JMixinsDemo.vue?vue&type=style&index=0&id=0002a6e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports